/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserFollowTeamList = {
    type: 'array',
    contains: {
        type: 'UserFollowTeam',
    },
} as const;
